export default "__VITE_ASSET__DhifLDlx__"